import Router from 'vue-router'
import Vue from 'vue'
import assist from '@/utils/commonality'
import store from '@/store'
Vue.use(Router)

//  先注释掉  忘记了是干什么的了
// const originalPush = Router.prototype.push 
// Router.prototype.push = function push(location) {
//   return originalPush.call(this,location).catch(err => err)
// }

import Home from '@/view/home'
// import message from '@/view/message'
// import answer from '@/view/answer'
// import axswersuccess from '@/view/axswersuccess'
const router =  new Router({
  // mode: "history", 
  routes :[
  { 
    path:'/',
    component:Home,
   
  },
  { 
    path:'/message',
    component:() => import('@/view/message'),
   
  },
  { 
    path:'/answer',
    component:() => import('@/view/answer'),
  },
  { 
    path:'/answersuccess',
    component:() => import('@/view/answersuccess'),
  },
  { 
    path:'/pay',
    component:() => import('@/view/zf'),
  },
  { 
    path:'/result',
    component:() => import('@/view/result'),
  },

  ]


})


// 全局守卫：导航守卫
router.beforeEach(async(to, from, next) => {

  


     if (to.fullPath==='/answer' && from.fullPath === '/answersuccess') {
      next('/message')
    }else if (to.fullPath !=='/') {
      next()
    }


      let isfoupay = assist.getCache('paycomplete') //如果为true就代表支付了
                                                    //如果取不到值就代表没支付
    if (to.fullPath==='/answersuccess' && from.fullPath ==='/pay' && isfoupay) {
        next('/')
    }else {
      next()
    }

  
    next()

})

export default router